import Box from "@mui/material/Box";
import React from "react";

const PendingInbox = props => {

	const { text = "Loading Your Inbox..." } = props;

	return (
		<Box className="cmp-loading--access" mt={10}>
			<div className="cmp-loading--access__loading">
				<div className="cmp-loading--access__loading-icon">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
				<span>{text}</span>
			</div>
		</Box>
	);
};

export default PendingInbox;